<template>
  <AppBanner class="!px-0 @md/main:!px-8">
    <div
      class="club-banner"
      :style="{
        backgroundImage: `url('${$theme.assets.banner}')`,
      }"
    >
      <div class="hidden @lg/main:flex flex-col justify-center gap-3">
        <h1 class="text-[32px] leading-9 font-bold font-club uppercase">
          Play while supporting your team
        </h1>
        <p class="justify-start text-base font-medium">
          Play for the chance to win incredible prizes!
        </p>
      </div>

      <div
        class="flex flex-col gap-1 items-center @lg/main:items-end @lg/main:max-w-[40%] z-10"
      >
        <div class="text-lg font-bold @lg/main:text-right">
          Every ticket supports
        </div>
        <div
          class="flex gap-2 items-center justify-center @lg/main:justify-end"
        >
          <img
            :src="$theme.assets.logoBanner"
            alt="Foundation"
            class="h-auto w-auto max-h-[44px] shrink-0 object-contain"
          />
          <div class="text-2xl font-bold">
            {{ $theme.displayName.toUpperCase() }} FC
          </div>
        </div>
      </div>
    </div>
  </AppBanner>
</template>

<style lang="scss" scoped>
.club-banner {
  @apply w-full text-pure-white p-3 @md/main:p-5 @md/main:rounded-lg inline-flex justify-center @lg/main:justify-between relative bg-center bg-[length:auto_100%];
}

.club-banner__logo {
  @apply absolute top-0 bottom-0 right-[5%] left-0 bg-no-repeat bg-right opacity-20;
  background-size: 20%;
}
</style>
